export default __webpack_public_path__ + "static/Raleway-VariableFont_wght-3fefe681f4c62116679be7083df960d4.ttf";